module.exports = __webpack_public_path__ + "img/card-in.2fa65dd2.svg";